import { useCallback, useEffect } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useBeforeUnload, useBlocker } from 'react-router-dom';

export default function LeavingWithoutSavingPrompt() {
  const {
    formState: { isDirty, isSubmitted, isSubmitSuccessful },
  } = useFormContext();

  const shouldPrevent = isDirty && !(isSubmitted && isSubmitSuccessful);
  const blocker = useBlocker(shouldPrevent);

  useBeforeUnload(
    useCallback(
      (event) => {
        if (shouldPrevent) {
          event.preventDefault();
          event.returnValue = 'Do you want to discard all changes?';
        }
      },
      [shouldPrevent],
    ),
    { capture: true },
  );

  const handleReset = () => {
    blocker.reset?.();
  };
  const handleContinue = () => {
    blocker.proceed?.();
  };

  useEffect(() => {
    if (!shouldPrevent) {
      blocker?.proceed?.();
    }
  }, [blocker, shouldPrevent]);

  return blocker.state === 'blocked' ? (
    <Dialog open fullWidth maxWidth="sm" onClose={handleReset}>
      <DialogTitle>Do you want to discard all changes?</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>Any changes you've made will be lost.</DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button variant="outlined" onClick={handleReset}>
          Continue editing
        </Button>
        <Button autoFocus variant="contained" color="error" onClick={handleContinue}>
          Discard the changes
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
}
